import * as React from "react";
import { FunctionComponent, useEffect, useRef } from "react";
import { WindowState, EnquiryWidgetSettings, WidgetInstance } from "../types";
import * as ClassNames from "classnames";
import HgvWidgetContainer from "./HgvWidgetContainer";

interface Props {
  className?: string;
  settings: EnquiryWidgetSettings;
}

const EnquiryWidget: FunctionComponent<Props> = ({ className, settings }) => {
  const ref = useRef<HTMLDivElement>(null);
  const widgetInstanceRef = useRef<WidgetInstance>();

  const initWidget = () => {
    if (!ref.current) return;

    const { BookingSüdtirol } = (window as unknown) as WindowState;
    widgetInstanceRef.current = new BookingSüdtirol.Widgets.Enquiry(
      ref.current,
      settings
    );
    widgetInstanceRef.current.render();
  };

  useEffect(() => {
    return () => {
      widgetInstanceRef.current?.unmount();
    };
  }, []);

  return (
    <div className={ClassNames("Module__Wrapper", className)}>
      <HgvWidgetContainer
        widgetInstance={widgetInstanceRef.current}
        initWidget={initWidget}
        settings={settings}
        enableLazyload={true}
      >
        <div className="EnquiryWidget__Container" ref={ref} />
      </HgvWidgetContainer>
    </div>
  );
};

export default EnquiryWidget;
